var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container py-5"},[_c('v-img',{staticClass:"bee-flying",attrs:{"src":_vm.beeFlying,"height":_vm.size,"contain":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }